import { render, staticRenderFns } from "./MarkdownText.vue?vue&type=template&id=797d0922&scoped=true"
import script from "./MarkdownText.vue?vue&type=script&lang=js"
export * from "./MarkdownText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d0922",
  null
  
)

export default component.exports